import React from 'react';
import { ModalDialog } from '@/Components/ModalDialog/ModalDialog';
import { useLocalization } from '@/Hooks';
import { useSingleDocumentPrintModal } from './hooks/useSingleDocumentPrintModal';

type Props = {
  onClose: () => void;
};

export const SingleDocumentSendModal = ({ onClose }: Props) => {
  const {
    buttons: { Yes },
    modalWindows: {
      emailSendModal: { SingleDocumentSendModal },
    },
  } = useLocalization();

  const { sendSingleDocument } = useSingleDocumentPrintModal();

  return (
    <ModalDialog
      title={SingleDocumentSendModal.Title}
      text={SingleDocumentSendModal.Text}
      onNo={onClose}
      okButtonText={Yes}
      onOk={sendSingleDocument}
    />
  );
};
